import { publicAxios } from "../../../config/apiConfig";
import { processProductImages, processProductsImages } from "../../../utils/imageUtils";
import {
  GET_ALL_PRODUCTS_FAILURE,
  GET_ALL_PRODUCTS_REQUEST,
  GET_ALL_PRODUCTS_SUCCESS,
  FIND_PRODUCT_BY_ID_FAILURE,
  FIND_PRODUCT_BY_ID_REQUEST,
  FIND_PRODUCT_BY_ID_SUCCESS,
  FIND_PRODUCTS_FAILURE,
  FIND_PRODUCTS_REQUEST,
  FIND_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_BY_CATEGORY_REQUEST,
  GET_ALL_PRODUCTS_BY_CATEGORY_SUCCESS,
  GET_ALL_PRODUCTS_BY_CATEGORY_FAILURE,
  GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_REQUEST,
  GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_SUCCESS,
  GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_REQUEST,
  GET_ALL_PRODUCTS_BY_BRAND_SUCCESS,
  GET_ALL_PRODUCTS_BY_BRAND_FAILURE,
  FIND_PRODUCTS_BY_BRAND_FAILURE,
  FIND_PRODUCTS_BY_BRAND_REQUEST,
  FIND_PRODUCTS_BY_BRAND_SUCCESS,
  FIND_PRODUCTS_BY_OFFER_REQUEST,
  FIND_PRODUCTS_BY_OFFER_FAILURE,
  FIND_PRODUCTS_BY_OFFER_SUCCESS,
  FIND_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS,
  FIND_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST,
  FIND_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST,
  GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS,
  GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_OFFERS_REQUEST,
  GET_ALL_PRODUCTS_BY_OFFERS_SUCCESS,
  GET_ALL_PRODUCTS_BY_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_FILTER_REQUEST,
  GET_ALL_PRODUCTS_BY_FILTER_SUCCESS,
  GET_ALL_PRODUCTS_BY_FILTER_FAILURE,
  GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_REQUEST,
  GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_SUCCESS,
  GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_FAILURE,
  SEARCH_PRODUCTS_REQUEST,
  SEARCH_PRODUCTS_SUCCESS,
  SEARCH_PRODUCTS_FAILURE,
  GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_FAILURE,
  GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_SUCCESS,
  GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_REQUEST,
  FIND_PRODUCTS_BY_VENDOR_REQUEST,
  FIND_PRODUCTS_BY_VENDOR_SUCCESS,
  FIND_PRODUCTS_BY_VENDOR_FAILURE,
  GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_REQUEST,
  GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_SUCCESS,
  GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_REQUEST,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_SUCCESS,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_FAILURE,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_REQUEST,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_SUCCESS,
  GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_FAILURE
} from "./ActionType";

export const findProducts = (reqData) => async (dispatch) => {
  dispatch({ type: FIND_PRODUCTS_REQUEST });
  try {
    // Remove null or undefined parameters
    const queryString = Object.entries(reqData)
      .filter(([_, value]) => value != null) // Exclude null or undefined values
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    // Make the API request
    const response = await publicAxios.get(`filter_products?${queryString}`);
    dispatch({ type: FIND_PRODUCTS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FIND_PRODUCTS_FAILURE, payload: error.message });
  }
};

export const findProductsByBrand = (reqData) => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTS_BY_BRAND_REQUEST });
  try {
    // Remove null or undefined parameters
    const queryString = Object.entries(reqData)
      .filter(([_, value]) => value != null) // Exclude null or undefined values
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    // Make the API request
    const response = await publicAxios.get(`brand_products?${queryString}`);
    dispatch({
      type: GET_ALL_PRODUCTS_BY_BRAND_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_PRODUCTS_BY_BRAND_FAILURE,
      payload: error.response?.data?.response
    });
  }
};

export const getAllProductByFilter = (reqData) => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTS_BY_FILTER_REQUEST });
  try {
    // Remove null or undefined parameters
    const queryString = Object.entries(reqData)
      .filter(([_, value]) => value != null) // Exclude null or undefined values
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    // Make the API request
    const response = await publicAxios.get(`products_filter?${queryString}`);
    dispatch({
      type: GET_ALL_PRODUCTS_BY_FILTER_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_PRODUCTS_BY_FILTER_FAILURE,
      payload: error.response?.data?.response
    });
  }
};

export const getAllProductsBySubCategoryFilter = (reqData) => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_REQUEST });
  try {
    // Remove null or undefined parameters
    const queryString = Object.entries(reqData)
      .filter(([_, value]) => value != null) // Exclude null or undefined values
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    // Make the API request
    const response = await publicAxios.get(`filters_products?${queryString}`);
    dispatch({
      type: GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_FAILURE,
      payload: error.response?.data?.response
    });
  }
};

export const findProductsByOffers = (reqData) => async (dispatch) => {
  dispatch({ type: FIND_PRODUCTS_BY_OFFER_REQUEST });
  try {
    // Remove null or undefined parameters
    const queryString = Object.entries(reqData)
      .filter(([_, value]) => value != null) // Exclude null or undefined values
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    // Make the API request
    const response = await publicAxios.get(`offer_products?${queryString}`);
    dispatch({ type: FIND_PRODUCTS_BY_OFFER_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FIND_PRODUCTS_BY_OFFER_FAILURE,
      payload: error.response?.data?.response
    });
  }
};

export const findProductsByBrandAndOffers = (reqData) => async (dispatch) => {
  dispatch({ type: FIND_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST });
  try {
    // Remove null or undefined parameters
    const queryString = Object.entries(reqData)
      .filter(([_, value]) => value != null) // Exclude null or undefined values
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    // Make the API request
    const response = await publicAxios.get(
      `brand_offer_products?${queryString}`
    );
    dispatch({
      type: FIND_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FIND_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE,
      payload: error.response?.data?.response
    });
  }
};
// do somehting here

export const findProductById = (productId, selectedCurrency) => async (dispatch) => {
  dispatch({ type: FIND_PRODUCT_BY_ID_REQUEST });
  try {
    const response = await publicAxios.get(`product/${productId}`);
    // Process images to replace localhost URLs
    const processedData = processProductImages(response.data);
    dispatch({ type: FIND_PRODUCT_BY_ID_SUCCESS, payload: processedData });

  } catch (error) {
    dispatch({ type: FIND_PRODUCT_BY_ID_FAILURE, payload: error.message });
  }
};

export const getAllProducts = () => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTS_REQUEST });
  try {
    const response = await publicAxios.get(`products`);
    // Process images to replace localhost URLs
    const processedData = processProductsImages(response.data);
    dispatch({ type: GET_ALL_PRODUCTS_SUCCESS, payload: processedData });
  } catch (error) {
    dispatch({ type: GET_ALL_PRODUCTS_FAILURE, payload: error.message });
  }
};

export const getAllProductsByBrand = (brand) => async (dispatch) => {
  dispatch({ type: FIND_PRODUCTS_BY_BRAND_REQUEST });
  try {
    const response = await publicAxios.get(`products/brand/${brand}`);
    dispatch({
      type: FIND_PRODUCTS_BY_BRAND_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FIND_PRODUCTS_BY_BRAND_FAILURE,
      payload: error.message
    });
  }
};
export const getAllProductsByVendor = (vendor) => async (dispatch) => {
  dispatch({ type: FIND_PRODUCTS_BY_VENDOR_REQUEST });
  try {
    const response = await publicAxios.get(`products/vendor/${vendor}`);
    dispatch({
      type: FIND_PRODUCTS_BY_VENDOR_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FIND_PRODUCTS_BY_VENDOR_FAILURE,
      payload: error.message
    });
  }
};

export const getAllProductsByOffers = (offers) => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTS_BY_OFFERS_REQUEST });
  try {
    const response = await publicAxios.get(`products/offers/${offers}`);
    dispatch({
      type: GET_ALL_PRODUCTS_BY_OFFERS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_PRODUCTS_BY_OFFERS_FAILURE,
      payload: error.message
    });
  }
};
export const getAllProductsByBrandAndOffers =
  (brand, offers) => async (dispatch) => {
    dispatch({ type: GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST });
    try {
      const response = await publicAxios.get(
        `products/brand/${brand}/offers/${offers}`
      );
      dispatch({
        type: GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE,
        payload: error.message
      });
    }
  };

export const getAllProductsByVendorAndOffers =
  (vendor, offers) => async (dispatch) => {
    dispatch({ type: GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_REQUEST });
    try {
      const response = await publicAxios.get(
        `products/vendor/${vendor}/offers/${offers}`
      );
      dispatch({
        type: GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_FAILURE,
        payload: error.message
      });
    }
  };

export const getAllProductsByBrandAndVendorAndOffers =
  (brand, vendor, offers) => async (dispatch) => {
    dispatch({ type: GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_REQUEST });
    try {
      const response = await publicAxios.get(
        `products/brand/${brand}/vendor/${vendor}/offers/${offers}`
      );
      dispatch({
        type: GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_FAILURE,
        payload: error.message
      });
    }
  };

export const getAllProductsByBrandAndVendor =
  (brand, vendor) => async (dispatch) => {
    dispatch({ type: GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_REQUEST });
    try {
      const response = await publicAxios.get(
        `products/brand/${brand}/vendor/${vendor}`
      );
      dispatch({
        type: GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_FAILURE,
        payload: error.message
      });
    }
  };

export const getAllProductsByCategory =
  (productCategory, category) => async (dispatch) => {
    dispatch({ type: GET_ALL_PRODUCTS_BY_CATEGORY_REQUEST });
    try {
      const response = await publicAxios.get(
        `products/productCategory/${productCategory}/category/${category}`
      );
      // Process images to replace localhost URLs
      const processedData = processProductsImages(response.data);
      dispatch({
        type: GET_ALL_PRODUCTS_BY_CATEGORY_SUCCESS,
        payload: processedData
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_PRODUCTS_BY_CATEGORY_FAILURE,
        payload: error.message
      });
    }
  };

export const getAllProductsByGrandParentCategory =
  (category) => async (dispatch) => {
    dispatch({ type: GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_REQUEST });
    try {
      const response = await publicAxios.get(`products/category/${category}`);
      dispatch({
        type: GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_SUCCESS,
        payload: response.data
      });
    } catch (error) {
      dispatch({
        type: GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_FAILURE,
        payload: error.message
      });
    }
  };

export const searchProducts = (query) => async (dispatch) => {
  dispatch({ type: SEARCH_PRODUCTS_REQUEST });
  try {
    const response = await publicAxios.get(`products/search/${query}`);
    if (response?.data) {
      dispatch({ type: SEARCH_PRODUCTS_SUCCESS, payload: response.data });
    }
  } catch (error) {
    dispatch({ type: SEARCH_PRODUCTS_FAILURE, payload: error.message });
  }
};

export const getAllProductBySearchAndFilter = (reqData) => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_REQUEST });
  try {
    // Remove null or undefined parameters
    const queryString = Object.entries(reqData)
      .filter(([_, value]) => value != null) // Exclude null or undefined values
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    // Make the API request
    const response = await publicAxios.get(`products/search?${queryString}`);
    dispatch({
      type: GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_FAILURE,
      payload: error.response?.data?.response
    });
  }
};
